import React, { ReactNode } from 'react'
import styled from 'styled-components'
import { Col, Container, Row } from 'styled-bootstrap-grid'
import Header from 'components/content/Header'
import Footer from 'containers/Footer'

interface TemplateProps {
  children: ReactNode
}

const Template: React.FC<TemplateProps> = ({ children }) => (
  <div className="wrapper">
    <div className="content">
      <Header />
      <Page>
        <Container>
          <Row>
            <Col>{children}</Col>
          </Row>
        </Container>
      </Page>
    </div>
    <Footer />
  </div>
)

export default Template

const Page = styled.div`
  padding: 60px 0;
`
